import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

/**
 * Server Environment Variables
 * - Have specified default values for all variables since otherwise it causes issues with storybook
 */
export const env = createEnv({
  server: {
    SR_URI: z.string().url().default('https://localhost:8083/service-request'),
    SCHEMA_URI: z.string().url().default('https://localhost:8083/schema'),
    UAM_URI: z.string().url().default('https://localhost:8083/uam'),
    DOCUMENT_STORE_MASTER_URI: z
      .string()
      .url()
      .default('https://localhost:8083/document-store'),
    DOCUMENT_STORE_VOLUME_URI: z
      .string()
      .url()
      .default('https://localhost:8083/document-store-volume'),
    PAGE_SIZE: z.coerce.number().min(1).default(25),
    SESSION_TTL_IN_SECONDS: z.coerce.number().min(1).default(600),
    SESSION_ENCRYPTION_PASSWORD: z.string().min(1).default('cookie-password'),
    ALLOWED_DOMAINS: z
      .string()
      .min(1)
      .default(
        'https://hdfc.bank.in,https://hdfcbank.com,https://hdfcbankuat.com'
      )
      .transform((domains) =>
        domains.split(',').map((domain) => domain.trim())
      ),
    PRIVATE_KEY: z.string().default('decryption-key'),
    JWT_TOKEN_KEY: z.string().default('jwt-key'),

    DIGICERT_DOMAINS: z
      .string()
      .min(1)
      .default('xpressforms.hdfc.bank.in')
      .transform((d) => d.split(',').map((d) => d.trim())),

    OBSERVABILITY_ENABLED: z.coerce.boolean().default(true),

    ENVIRONMENT: z.string().default('development'),
    SAMPLE_RATE: z.coerce.number().min(0).max(1).default(0.1),
    SERVICE_VERSION: z.string().optional(),
    OTEL_RESOURCE_ATTRIBUTES: z.string().default(''),
    OTEL_EXPORTER_TRACES_ENDPOINT: z
      .string()
      .url()
      .default('http://otel-collector/v1/traces'),
    APM_PATH: z.string().default('analytics'),
    OTEL_EXPORTER_OTLP_ENDPOINT: z
      .string()
      .url()
      .default('http://localhost:4318'),
    APP_URL: z
      .string()
      .url()
      .default(
        process.env.NODE_ENV === 'production'
          ? 'http://frontend' // K8s service URL for internal communication
          : 'http://localhost:3000' // Local dev
      ),

    // App URL for Edge runtime (needed for absolute URLs in middleware)
    // Production (OpenShift): Set to Kubernetes service URL (e.g., http://frontend)
    // Development: Defaults to localhost

    // Development Flags
    DEV_FLAG_DOMAIN: z.string().default('I'),
    DEV_OTEL_TESTING: z.coerce.boolean().default(false),
    //make sure the key name is same in openshift
    DECRYPTION_KEY: z.string().default(''),
    DB_NAME: z.string().default(''),
    DB_USER: z.string().default(''),
    DB_URL: z.string().default(''),
    DB_PASSWORD: z.string().default(''),
    DB_REF_STR: z.string().default(''),
    DB_FLAG: z.string().default('false'),
    DB_CA_PATH: z.string().default(''),
    EKYC_REDIRECT_URL: z
      .string()
      .url()
      .default('https://pehchaan-pr.hdfcbank.com/'),
    EKYC_REDIRECT_URL_DR: z
      .string()
      .url()
      .default('https://pehchaan-dr.hdfcbank.com/'),
    CUSTOMER_EXPIRY_MINUTES: z.coerce.number().min(0).default(15),
    VERIFY_SESSION_FLAG: z.string().default('false'),
  },
  experimental__runtimeEnv: process.env,
})
